// modules
import { handleActions } from 'redux-actions'

// actions
import { setTelemedicineBillingCodes } from 'src/store/modules/dashboard/telemedicineDashboard'

const initialState = {
  telemedicineBillingCodes: []
}

export default handleActions(
  {
    [setTelemedicineBillingCodes](
      state,
      { payload: telemedicineBillingCodes }
    ) {
      return {
        ...state,
        telemedicineBillingCodes
      }
    }
  },
  initialState
)
